module.exports = __webpack_public_path__ + "img/parameter1.6ad1b94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/parameter1.jpg
// module id = 9Dyk
// module chunks = 0